import { extend } from './extend';

/**
 * Mixin a given set of mixins into target.
 * Invoke this method in the context of a superclass
 * to create mixin application definition which can be inherited.
 *
 * @this {Function} Constructor function.
 * @param {...Object} mixins
 * @return {Function}
 */
function mixin(...mixins) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  let mixed = this;

  if (!mixed.extend) {
    mixed.extend = extend;
  }

  mixins.forEach((mix) => {
    mixed = mixed.extend(mix);
  });

  return mixed;
}

export { mixin };
